module.exports = __webpack_public_path__ + "static/media/8OLA5.64a5aee0.jpg";